<template>
  <div class="flex items-center justify-center h-full">
    <!-- Three-dot dropdown menu -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <vs-button
        v-if="params.data"
        radius
        size="large"
        color="primary"
        type="flat"
        icon-pack="material-icons"
        icon="more_horiz"
        class="more-actions-button"
      >
      </vs-button>

      <vs-dropdown-menu class="actions-dropdown-menu">
        <ul class="actions-dropdown-list">
          <!-- 1. Send message -->
          <li
            class="action-dropdown-item"
            :class="{ disabled: !hasContact }"
            @click="hasContact ? sendMessage() : null">
            <feather-icon icon="SendIcon" svgClasses="h-4 w-4"></feather-icon>
            <span>Send message</span>
            <span v-if="!hasContact" class="text-muted">(Contact deleted)</span>
          </li>

          <!-- 2. Show status page -->
          <li
            class="action-dropdown-item"
            @click="showStatusPage">
            <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4"></feather-icon>
            <span>Show status page</span>
          </li>

          <!-- 3. View contact -->
          <li
            class="action-dropdown-item"
            :class="{ disabled: !hasContact }"
            @click="hasContact ? viewContact() : null">
            <feather-icon icon="EyeIcon" svgClasses="h-4 w-4"></feather-icon>
            <span>View contact</span>
            <span v-if="!hasContact" class="text-muted">(Contact deleted)</span>
          </li>

          <!-- Divider -->
          <li class="action-dropdown-divider"></li>

          <!-- 4. Remove from queue -->
          <li
            class="action-dropdown-item danger"
            @click="removeFromQueue">
            <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4"></feather-icon>
            <span>Remove from queue</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  name: 'WaitingListCellRendererActions',
  computed: {
    hasContact() {
      return this.params && this.params.data && this.params.data.contact != null;
    },
  },
  methods: {
    sendMessage() {
      if (!this.hasContact) return;
      this.params.context.componentParent.waitingListToSendMessage = this.params.data;
    },
    showStatusPage() {
      this.params.context.componentParent.showStatusPage(this.params.data);
    },
    viewContact() {
      if (!this.hasContact) return;
      this.params.context.componentParent.viewContactFromWaitingList(this.params.data);
    },
    removeFromQueue() {
      this.params.context.componentParent.removeCustomerFromQueue(this.params.data);
    },
  },
};
</script>

<style scoped>
.more-actions-button::v-deep .material-icons {
  font-size: 1.8rem;
}
.actions-dropdown-list {
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 200px;
}

.action-dropdown-item {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  font-size: 0.9rem;
}

.action-dropdown-item:hover:not(.disabled) {
  background-color: rgba(var(--vs-primary), 0.05);
}

.action-dropdown-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-dropdown-item.danger {
  color: rgba(var(--vs-danger), 1);
}

.action-dropdown-item.danger:hover {
  background-color: rgba(var(--vs-danger), 0.05);
}

.action-dropdown-item .text-muted {
  margin-left: auto;
  font-size: 0.75rem;
  opacity: 0.6;
}

.action-dropdown-divider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 4px 0;
}
</style>
